// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стили для модального окна создания чеклиста */

.h81KJyF56wiRUq4aA02Q {
  --modal-enter-duration: 0.3s;
  --modal-leave-duration: 0.2s;
}

.h81KJyF56wiRUq4aA02Q .ant-modal-content {
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: LjD9N36kBVwuQ3qgphdl 0.3s ease-out;
}

@keyframes LjD9N36kBVwuQ3qgphdl {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.h81KJyF56wiRUq4aA02Q .ant-modal-header {
  background: white;
  border-bottom: 1px solid #f0f0f0;
  padding: 16px 0;
}

.h81KJyF56wiRUq4aA02Q .ant-modal-title {
  color: #262626 !important;
  font-weight: 600;
}

.h81KJyF56wiRUq4aA02Q .ant-modal-close {
  color: #8c8c8c;
}

.h81KJyF56wiRUq4aA02Q .ant-modal-close:hover {
  color: #262626;
}

.h81KJyF56wiRUq4aA02Q .ant-modal-body {
  padding: 24px;
  max-height: 70vh;
  overflow-y: auto;
}

.h81KJyF56wiRUq4aA02Q .ant-modal-footer {
  border-top: 1px solid #f0f0f0;
  padding: 16px 24px;
  background: #fafafa;
}

/* Содержимое модального окна */
.g9KV2T4wsSoipLL6PnfV {
  position: relative;
  animation: jlPdfwlJRsNyeDuSSvzH 0.4s ease-out 0.1s both;
}

@keyframes jlPdfwlJRsNyeDuSSvzH {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Переключатель типа чеклиста */
.a7TSWMEjfq20PYk8hWK2 {
  width: 100%;
  display: flex;
  gap: 12px;
}

.a7TSWMEjfq20PYk8hWK2 .ant-radio-button-wrapper {
  flex: 1;
  text-align: center;
  height: 48px;
  line-height: 46px;
  border-radius: 8px;
  transition: all 0.2s ease;
  border-width: 1px;
}

.a7TSWMEjfq20PYk8hWK2 .ant-radio-button-wrapper:first-child {
  border-radius: 8px;
}

.a7TSWMEjfq20PYk8hWK2 .ant-radio-button-wrapper:last-child {
  border-radius: 8px;
}

.a7TSWMEjfq20PYk8hWK2 .ant-radio-button-wrapper-checked {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  border-color: #1890ff;
  color: white;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.a7TSWMEjfq20PYk8hWK2 .ant-radio-button-wrapper:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Поле ввода названия */
.NJf3stFNO1mPsQwU95Aw {
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.NJf3stFNO1mPsQwU95Aw:focus {
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
  border-color: #1890ff;
}

.NJf3stFNO1mPsQwU95Aw .ant-input {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 16px;
  line-height: 1.5;
}

/* Счетчик символов в поле */
.QBKbvHISaHert1bAyWwy {
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 12px;
  pointer-events: none;
}

/* Общий счетчик символов */
.c5k85ZRkAAnGHslOWRoL {
  text-align: right;
  margin-bottom: 16px;
  font-size: 13px;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* Подсказки */
.awSwrzeGg4L5k_bh0KqN {
  background: linear-gradient(135deg, #e6f7ff, #f0f9ff);
  border: 1px solid #91d5ff;
  border-radius: 8px;
  padding: 12px 16px 12px 24px;
  margin-top: 16px;
  position: relative;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: Bhrz4JKG0Gmz9ZHuHsYb 0.3s ease-out;
}

@keyframes Bhrz4JKG0Gmz9ZHuHsYb {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.awSwrzeGg4L5k_bh0KqN::before {
  content: '';
  position: absolute;
  left: 8px;
  top: -1px;
  width: 4px;
  height: calc(100% + 2px);
  background: linear-gradient(to bottom, #1890ff, #096dd9);
  border-radius: 2px;
}

/* Кнопка закрытия подсказки */
.tway_mggawIykGN_aGiq {
  color: #8c8c8c !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  min-width: 24px !important;
  height: 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
}

.tway_mggawIykGN_aGiq:hover {
  color: #ff4d4f !important;
  background: rgba(255, 77, 79, 0.1) !important;
}

.bjDLHrtTx6dh4Lwt_efu {
  flex: 1;
  margin-right: 8px;
}

.Ms_LDXeNJ4zpSeL5vYSW {
  animation: Bhrz4JKG0Gmz9ZHuHsYb 0.3s ease-out;
}

.W1RjRrRYvFTu5ShqwRWg {
  animation: zOsaBsPhjVJEXafgCF1Q 0.2s ease-in;
}

@keyframes zOsaBsPhjVJEXafgCF1Q {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
  }
}

/* Анимации для форм */
.h81KJyF56wiRUq4aA02Q .ant-form {
  min-height: 380px;
  transition: min-height 0.3s ease;
}

.h81KJyF56wiRUq4aA02Q .ant-form-item {
  transition: all 0.2s ease;
  margin-bottom: 20px;
}

.h81KJyF56wiRUq4aA02Q .ant-form-item-label > label {
  font-weight: 600;
  color: #262626;
}

/* Селектор родителя */
.TMDvhNlzrg3T_mFStuEH {
  transition: all 0.3s ease;
  overflow: hidden;
}

.TMDvhNlzrg3T_mFStuEH.mgoLaeJUgCS8r0aIVzow {
  max-height: 200px;
  opacity: 1;
  margin-bottom: 0;
}

.TMDvhNlzrg3T_mFStuEH.YgAx8D6juqnl22MdzpLA {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}

/* Стили для Select */
.h81KJyF56wiRUq4aA02Q .ant-select-selector {
  border-radius: 8px !important;
  height: 48px !important;
  padding: 0 16px !important;
}

.h81KJyF56wiRUq4aA02Q .ant-select-selection-item {
  line-height: 46px !important;
  font-size: 16px;
}

.h81KJyF56wiRUq4aA02Q .ant-select-selection-placeholder {
  line-height: 46px !important;
  color: #bfbfbf;
}

/* Кнопки в футере */
.h81KJyF56wiRUq4aA02Q .ant-btn {
  border-radius: 8px;
  height: 40px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.h81KJyF56wiRUq4aA02Q .ant-btn-primary {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  border: none;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.h81KJyF56wiRUq4aA02Q .ant-btn-primary:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.h81KJyF56wiRUq4aA02Q .ant-btn-primary:disabled {
  background: #f5f5f5;
  color: #bfbfbf;
  border-color: #d9d9d9;
  transform: none;
  box-shadow: none;
}

.h81KJyF56wiRUq4aA02Q .ant-btn-text {
  color: #8c8c8c;
}

.h81KJyF56wiRUq4aA02Q .ant-btn-text:hover {
  color: #1890ff;
  background: rgba(24, 144, 255, 0.06);
}

/* Состояния валидации */
.h81KJyF56wiRUq4aA02Q .ant-form-item-has-error .ant-input {
  border-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);
}

.h81KJyF56wiRUq4aA02Q .ant-form-item-has-success .ant-input {
  border-color: #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.1);
}

.h81KJyF56wiRUq4aA02Q .ant-form-item-is-validating .ant-input {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
}

/* Адаптивность */
@media (max-width: 768px) {
  .h81KJyF56wiRUq4aA02Q {
    margin: 0;
    max-width: none;
  }
  
  .h81KJyF56wiRUq4aA02Q .ant-modal-content {
    border-radius: 0;
  }
  
  .a7TSWMEjfq20PYk8hWK2 .ant-radio-button-wrapper {
    font-size: 14px;
    height: 40px;
    line-height: 38px;
  }
  
  .NJf3stFNO1mPsQwU95Aw .ant-input {
    font-size: 16px; /* Предотвращаем зум на iOS */
  }
}

/* Загружающееся состояние */
.h81KJyF56wiRUq4aA02Q .ant-btn-loading {
  cursor: not-allowed;
}

.h81KJyF56wiRUq4aA02Q .ant-btn-loading-icon {
  margin-right: 8px;
}

/* Улучшенные тултипы */
.h81KJyF56wiRUq4aA02Q .anticon-info-circle {
  cursor: help;
  transition: color 0.3s ease;
}

.h81KJyF56wiRUq4aA02Q .anticon-info-circle:hover {
  color: #40a9ff;
} `, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/ChecklistCreateModal.module.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,6CAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,uDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,qDAAqD;EACrD,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6CAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,6CAAoC;AACtC;;AAEA;EACE,4CAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,iBAAiB;AACjB;EACE;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe,EAAE,6BAA6B;EAChD;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Стили для модального окна создания чеклиста */\n\n.createModal {\n  --modal-enter-duration: 0.3s;\n  --modal-leave-duration: 0.2s;\n}\n\n.createModal :global(.ant-modal-content) {\n  border-radius: 12px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.createModal :global(.ant-modal-header) {\n  background: white;\n  border-bottom: 1px solid #f0f0f0;\n  padding: 16px 0;\n}\n\n.createModal :global(.ant-modal-title) {\n  color: #262626 !important;\n  font-weight: 600;\n}\n\n.createModal :global(.ant-modal-close) {\n  color: #8c8c8c;\n}\n\n.createModal :global(.ant-modal-close:hover) {\n  color: #262626;\n}\n\n.createModal :global(.ant-modal-body) {\n  padding: 24px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.createModal :global(.ant-modal-footer) {\n  border-top: 1px solid #f0f0f0;\n  padding: 16px 24px;\n  background: #fafafa;\n}\n\n/* Содержимое модального окна */\n.modalContent {\n  position: relative;\n  animation: contentFadeIn 0.4s ease-out 0.1s both;\n}\n\n@keyframes contentFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Переключатель типа чеклиста */\n.typeSelector {\n  width: 100%;\n  display: flex;\n  gap: 12px;\n}\n\n.typeSelector :global(.ant-radio-button-wrapper) {\n  flex: 1;\n  text-align: center;\n  height: 48px;\n  line-height: 46px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  border-width: 1px;\n}\n\n.typeSelector :global(.ant-radio-button-wrapper:first-child) {\n  border-radius: 8px;\n}\n\n.typeSelector :global(.ant-radio-button-wrapper:last-child) {\n  border-radius: 8px;\n}\n\n.typeSelector :global(.ant-radio-button-wrapper-checked) {\n  background: linear-gradient(135deg, #1890ff, #096dd9);\n  border-color: #1890ff;\n  color: white;\n  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);\n}\n\n.typeSelector :global(.ant-radio-button-wrapper:hover) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Поле ввода названия */\n.nameInput {\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n\n.nameInput:focus {\n  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);\n  border-color: #1890ff;\n}\n\n.nameInput :global(.ant-input) {\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 16px;\n  line-height: 1.5;\n}\n\n/* Счетчик символов в поле */\n.characterCount {\n  position: absolute;\n  bottom: 8px;\n  right: 12px;\n  font-size: 12px;\n  pointer-events: none;\n}\n\n/* Общий счетчик символов */\n.characterCounter {\n  text-align: right;\n  margin-bottom: 16px;\n  font-size: 13px;\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* Подсказки */\n.hints {\n  background: linear-gradient(135deg, #e6f7ff, #f0f9ff);\n  border: 1px solid #91d5ff;\n  border-radius: 8px;\n  padding: 12px 16px 12px 24px;\n  margin-top: 16px;\n  position: relative;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  animation: hintSlideIn 0.3s ease-out;\n}\n\n@keyframes hintSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.hints::before {\n  content: '';\n  position: absolute;\n  left: 8px;\n  top: -1px;\n  width: 4px;\n  height: calc(100% + 2px);\n  background: linear-gradient(to bottom, #1890ff, #096dd9);\n  border-radius: 2px;\n}\n\n/* Кнопка закрытия подсказки */\n.closeHint {\n  color: #8c8c8c !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  min-width: 24px !important;\n  height: 24px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0;\n}\n\n.closeHint:hover {\n  color: #ff4d4f !important;\n  background: rgba(255, 77, 79, 0.1) !important;\n}\n\n.hintContent {\n  flex: 1;\n  margin-right: 8px;\n}\n\n.hintVisible {\n  animation: hintSlideIn 0.3s ease-out;\n}\n\n.hintHidden {\n  animation: hintSlideOut 0.2s ease-in;\n}\n\n@keyframes hintSlideOut {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n}\n\n/* Анимации для форм */\n.createModal :global(.ant-form) {\n  min-height: 380px;\n  transition: min-height 0.3s ease;\n}\n\n.createModal :global(.ant-form-item) {\n  transition: all 0.2s ease;\n  margin-bottom: 20px;\n}\n\n.createModal :global(.ant-form-item-label > label) {\n  font-weight: 600;\n  color: #262626;\n}\n\n/* Селектор родителя */\n.parentSelector {\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.parentSelector.visible {\n  max-height: 200px;\n  opacity: 1;\n  margin-bottom: 0;\n}\n\n.parentSelector.hidden {\n  max-height: 0;\n  opacity: 0;\n  margin-bottom: 0;\n}\n\n/* Стили для Select */\n.createModal :global(.ant-select-selector) {\n  border-radius: 8px !important;\n  height: 48px !important;\n  padding: 0 16px !important;\n}\n\n.createModal :global(.ant-select-selection-item) {\n  line-height: 46px !important;\n  font-size: 16px;\n}\n\n.createModal :global(.ant-select-selection-placeholder) {\n  line-height: 46px !important;\n  color: #bfbfbf;\n}\n\n/* Кнопки в футере */\n.createModal :global(.ant-btn) {\n  border-radius: 8px;\n  height: 40px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.createModal :global(.ant-btn-primary) {\n  background: linear-gradient(135deg, #1890ff, #096dd9);\n  border: none;\n  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);\n}\n\n.createModal :global(.ant-btn-primary:hover) {\n  background: linear-gradient(135deg, #40a9ff, #1890ff);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);\n}\n\n.createModal :global(.ant-btn-primary:disabled) {\n  background: #f5f5f5;\n  color: #bfbfbf;\n  border-color: #d9d9d9;\n  transform: none;\n  box-shadow: none;\n}\n\n.createModal :global(.ant-btn-text) {\n  color: #8c8c8c;\n}\n\n.createModal :global(.ant-btn-text:hover) {\n  color: #1890ff;\n  background: rgba(24, 144, 255, 0.06);\n}\n\n/* Состояния валидации */\n.createModal :global(.ant-form-item-has-error .ant-input) {\n  border-color: #ff4d4f;\n  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.1);\n}\n\n.createModal :global(.ant-form-item-has-success .ant-input) {\n  border-color: #52c41a;\n  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.1);\n}\n\n.createModal :global(.ant-form-item-is-validating .ant-input) {\n  border-color: #1890ff;\n  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);\n}\n\n/* Адаптивность */\n@media (max-width: 768px) {\n  .createModal {\n    margin: 0;\n    max-width: none;\n  }\n  \n  .createModal :global(.ant-modal-content) {\n    border-radius: 0;\n  }\n  \n  .typeSelector :global(.ant-radio-button-wrapper) {\n    font-size: 14px;\n    height: 40px;\n    line-height: 38px;\n  }\n  \n  .nameInput :global(.ant-input) {\n    font-size: 16px; /* Предотвращаем зум на iOS */\n  }\n}\n\n/* Загружающееся состояние */\n.createModal :global(.ant-btn-loading) {\n  cursor: not-allowed;\n}\n\n.createModal :global(.ant-btn-loading-icon) {\n  margin-right: 8px;\n}\n\n/* Улучшенные тултипы */\n.createModal :global(.anticon-info-circle) {\n  cursor: help;\n  transition: color 0.3s ease;\n}\n\n.createModal :global(.anticon-info-circle:hover) {\n  color: #40a9ff;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createModal": `h81KJyF56wiRUq4aA02Q`,
	"modalSlideIn": `LjD9N36kBVwuQ3qgphdl`,
	"modalContent": `g9KV2T4wsSoipLL6PnfV`,
	"contentFadeIn": `jlPdfwlJRsNyeDuSSvzH`,
	"typeSelector": `a7TSWMEjfq20PYk8hWK2`,
	"nameInput": `NJf3stFNO1mPsQwU95Aw`,
	"characterCount": `QBKbvHISaHert1bAyWwy`,
	"characterCounter": `c5k85ZRkAAnGHslOWRoL`,
	"hints": `awSwrzeGg4L5k_bh0KqN`,
	"hintSlideIn": `Bhrz4JKG0Gmz9ZHuHsYb`,
	"closeHint": `tway_mggawIykGN_aGiq`,
	"hintContent": `bjDLHrtTx6dh4Lwt_efu`,
	"hintVisible": `Ms_LDXeNJ4zpSeL5vYSW`,
	"hintHidden": `W1RjRrRYvFTu5ShqwRWg`,
	"hintSlideOut": `zOsaBsPhjVJEXafgCF1Q`,
	"parentSelector": `TMDvhNlzrg3T_mFStuEH`,
	"visible": `mgoLaeJUgCS8r0aIVzow`,
	"hidden": `YgAx8D6juqnl22MdzpLA`
};
export default ___CSS_LOADER_EXPORT___;
